<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form">
        <template slot="buttonArea">
          <el-button type="primary" @click="add" size="small"
            >{{ $t('text.addDevice') }}</el-button
          >
        </template>

        <template slot="tableColumn">
          <el-table-column prop="id" :label="$t('text.deviceId')" align="center">
          </el-table-column>

          <el-table-column
            prop="processorCode"
            :label="$t('text.walletOrCardType')"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="phoneNumber"
            :label="$t('text.walletOrCardNumber')"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="balance"
            :label="$t('text.balance')"
            align="center"
            :formatter="$formatter.FenToYuanToThousandth"
          >
          </el-table-column>

          <el-table-column
            fixed="right"
            align="center"
            :label="$t('text.actions')"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="edit(scope.row)"
                >{{ $t('text.edit') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </page>

      <SmsForwarderInfoEdit
        :show.sync="showDialog"
        :value="formData"
        :action="action"
      ></SmsForwarderInfoEdit>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import SmsForwarderInfoEdit from "./smsForwardInfo/SmsForwarderInfoEdit.vue";

export default {
  name: "SmsForwarderInfo",
  components: {
    page: Page,
    SmsForwarderInfoEdit: SmsForwarderInfoEdit
  },
  data() {
    return {
      url: "/smsForwarderInfo/selectList",
      action: "",
      showDialog: false,
      formData: null,
      form: {}
    };
  },
  methods: {
    edit(row) {
      this.action = "edit";
      this.formData = row;
      this.showDialog = true;
    },
    add() {
      this.action = "add";
      this.showDialog = true;
    }
  }
};
</script>

<style scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>
